import {useHistory} from "react-router-dom";
import React, {useState, useEffect} from 'react';

function InstructionPage() {
    const history = useHistory();

    function handleNextClick() {
        history.push("/settings");
        return true;
    }

    useEffect(function () {
        setTimeout(function () {
            BX24.fitWindow();
        }, 500)
    }, []);

    return (
        <div className="InstructionPage">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="title">
                            Перед началом импорта данных необходимо получить ключ для работы с RetailCRM
                        </div>
                    </div>

                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="legend">
                            <ul className="items">
                                <li><span className="number">1</span> <span
                                    className="text">Откройте ваш RetailCRM</span></li>
                                <li><span className="number">2</span> <span
                                    className="text">Зайдите в раздел настройки</span></li>
                                <li><span className="number">3</span> <span className="text">Раздел интеграции - ключи доступа к API</span>
                                </li>
                                <li><span className="number">4</span> <span className="text">Создайте ключ и скопируйте его шифр</span>
                                </li>
                            </ul>
                            <a href="#" className="button" onClick={handleNextClick}>
                                Далее
                            </a>
                        </div>
                        <div className="help">* Если у вас возникли трудности, Вы можете обратиться к нашим специалистам
                            по <a target="blank" href="mailto:bitrix24@severcode.ru">электронной почте</a>.
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-2 offset-10 text-right">
                        <div className="paging">
                            2 / 5
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default InstructionPage;
